import { useQuery } from '@tanstack/react-query'

import { fetchStakingParams } from '@/api'
import { queryKeys } from '@/queries/keys'

export function useBecomeValidatorBase() {
  const { data: stakingParams } = useQuery({
    queryKey: queryKeys.staking.params(),
    queryFn: fetchStakingParams,
    staleTime: 60_000,
  })

  const bondDenom = stakingParams?.bond_denom ?? 'abridge'
  const minimalDelegationAmount =
    stakingParams?.minimal_delegation_amount ?? '0'

  return {
    bondDenom,
    minimalDelegationAmount,
  }
}
